<template>
  <div class="help-page">
    <div class="top-nav">
      <div class="back" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <h1>{{ $t('Help Center') }}</h1>
      <div class="placeholder"></div>
    </div>

    <div class="help-body">
      <div class="cs-card">
        <div class="cs-avatar" aria-hidden="true">
          <svg viewBox="0 0 64 64" width="56" height="56">
            <circle cx="32" cy="32" r="32" fill="#f3d38a"/>
            <circle cx="32" cy="24" r="10" fill="#8f501f"/>
            <path d="M16 50c2-10 10-15 16-15s14 5 16 15" fill="#8f501f"/>
            <path d="M18 28a14 14 0 0 1 28 0v8a4 4 0 0 1-4 4h-2v-6h6" fill="none" stroke="#fff8e7" stroke-width="2.4" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="cs-info">
          <div class="cs-title">{{ $t('24h Online Service') }}</div>
          <div class="cs-desc">{{ $t('CS Online Desc') }}</div>
        </div>
        <div class="cs-actions">
          <button type="button" class="cs-btn" @click="goKefu">{{ $t('Online service') }}</button>
          <button type="button" class="cs-btn" @click="goKefu">{{ $t('Feedback to get rewards') }}</button>
        </div>
      </div>

      <div class="faq-head">{{ $t('FAQ') }}</div>

      <div v-if="loading" class="faq-empty">{{ $t('Loading...') }}</div>
      <div v-else-if="!categories.length" class="faq-empty">{{ $t('No FAQ yet') }}</div>
      <div v-else class="faq-list">
        <div v-for="cate in categories" :key="cate.id" class="faq-cate">
          <div class="faq-cate-hd" @click="toggleCate(cate.id)">
            <span class="faq-icon" v-html="cateIcon(cate)"></span>
            <span class="faq-cate-name">{{ cate.name }}</span>
            <i class="van-icon" :class="openId === cate.id ? 'van-icon-arrow-up' : 'van-icon-arrow-down'"></i>
          </div>
          <div v-show="openId === cate.id" class="faq-items">
            <div
              v-for="(item, idx) in cate.items"
              :key="item.id"
              class="faq-item"
              @click="openFaq(item.id)"
            >
              <span>{{ idx + 1 }}、{{ item.title }}</span>
              <i class="van-icon van-icon-arrow"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ICONS = {
  deposit: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none"><path d="M6 10h12v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8z" stroke="currentColor" stroke-width="1.7"/><path d="M8 10V8a4 4 0 0 1 8 0v2" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="15" r="1.4" fill="currentColor"/></svg>',
  withdraw: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none"><rect x="3" y="6" width="18" height="12" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="M3 10h18" stroke="currentColor" stroke-width="1.7"/><path d="M12 13v4M10 15h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
  game: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none"><rect x="3" y="8" width="18" height="10" rx="3" stroke="currentColor" stroke-width="1.7"/><path d="M8 13h4M10 11v4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><circle cx="16" cy="12" r="1" fill="currentColor"/><circle cx="18" cy="15" r="1" fill="currentColor"/></svg>',
  other: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none"><path d="M8 10a4 4 0 1 1 5.6 3.7c-.9.4-1.6 1.2-1.6 2.2V17" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><circle cx="12" cy="19.2" r="1" fill="currentColor"/></svg>',
};

export default {
  name: 'help',
  data() {
    return {
      loading: false,
      categories: [],
      openId: 0,
    };
  },
  created() {
    this.loadFaq();
  },
  methods: {
    loadFaq() {
      this.loading = true;
      const lang = (this.$i18n && this.$i18n.locale) || 'pt';
      this.$apiFun.post('/api/faq', { lang }).then((res) => {
        this.loading = false;
        if (res.code === 200) {
          this.categories = res.data || [];
          this.openId = this.categories.length ? this.categories[0].id : 0;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    toggleCate(id) {
      this.openId = this.openId === id ? 0 : id;
    },
    openFaq(id) {
      this.$router.push({ path: '/help/faq', query: { id } }).catch(() => {});
    },
    goKefu() {
      const cached =
        (this.$store.state.appInfo &&
          (this.$store.state.appInfo.service_link || this.$store.state.appInfo.kf_url)) ||
        '';
      const url = this.fillKfUrl(cached);
      if (url) {
        try {
          const u = new URL(url, window.location.href);
          if (u.protocol === 'http:' || u.protocol === 'https:') {
            window.location.href = url;
            return;
          }
        } catch (e) { /* fall through */ }
      }
      this.$router.push('/kefu').catch(() => {});
    },
    fillKfUrl(url) {
      const u = (this.$store && this.$store.state && this.$store.state.userInfo) || {};
      const id = String(u.id || u.userid || u.user_id || '');
      const name = encodeURIComponent(u.username || u.account || u.name || '');
      return String(url || '')
        .replace(/\{visiter_id\}/gi, id)
        .replace(/\{visiter_name\}/gi, name)
        .replace(/\{uid\}/gi, id)
        .replace(/\{userid\}/gi, id)
        .replace(/\{user_id\}/gi, id)
        .replace(/\{name\}/gi, name)
        .replace(/\{username\}/gi, name);
    },
    cateIcon(cate) {
      if (cate.icon) {
        return `<img src="${cate.icon}" alt="" width="22" height="22">`;
      }
      return ICONS[cate.icon_type] || ICONS.other;
    },
  },
};
</script>

<style scoped>
.help-page {
  min-height: 100vh;
  background: #f6efe4;
  color: #3d2a12;
}

.top-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(180deg, #fff8ea 0%, #f3e2c4 100%);
  border-bottom: 1px solid #ead1b2;
  position: sticky;
  top: 0;
  z-index: 20;
}

.top-nav h1 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #8f501f;
}

.back,
.placeholder {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back i {
  font-size: 20px;
  color: #8f501f;
}

.help-body {
  padding: 16px 14px 40px;
}

.cs-card {
  background: #fffdf8;
  border: 1px solid #ead1b2;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 8px 20px rgba(143, 80, 31, 0.08);
}

.cs-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 10px;
}

.cs-title {
  font-size: 16px;
  font-weight: 800;
  color: #5a3512;
}

.cs-desc {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.5;
  color: #8a6a45;
}

.cs-actions {
  display: flex;
  gap: 10px;
  margin-top: 14px;
}

.cs-btn {
  flex: 1;
  height: 36px;
  border-radius: 20px;
  border: 1px solid #d1a03e;
  background: #fff;
  color: #8f501f;
  font-size: 12px;
  font-weight: 700;
}

.faq-head {
  margin: 22px 0 10px;
  font-size: 16px;
  font-weight: 800;
  color: #b8860b;
  position: relative;
  display: inline-block;
}

.faq-head::after {
  content: '';
  display: block;
  width: 28px;
  height: 3px;
  margin-top: 4px;
  border-radius: 2px;
  background: #d1a03e;
}

.faq-list {
  background: #fffdf8;
  border: 1px solid #ead1b2;
  border-radius: 14px;
  overflow: hidden;
}

.faq-cate + .faq-cate {
  border-top: 1px solid #f0e2cc;
}

.faq-cate-hd {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 14px;
}

.faq-icon {
  width: 28px;
  height: 28px;
  color: #8f501f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.faq-cate-name {
  flex: 1;
  font-size: 14px;
  font-weight: 700;
}

.faq-cate-hd i {
  color: #b08960;
  font-size: 14px;
}

.faq-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 12px 52px;
  font-size: 13px;
  color: #6b4a28;
  border-top: 1px solid #f6efe4;
}

.faq-item i {
  color: #c4a27a;
  font-size: 12px;
}

.faq-empty {
  padding: 28px 0;
  text-align: center;
  color: #9a7b55;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/help.vue